jQuery(document).ready(function ($) {
    $('.slick-inline').slick();
    $('.carousel-tabs-section-widget ul.tabs li.tab label').click(function () {
        var thisTabNumber = $(this).attr('data-tab-number');
        var thisCarousel = $(this).closest('.tabs-group').find('.tab-content.tab-content-' + thisTabNumber + ' .slick-inline');
        if ($(thisCarousel).hasClass('needs-slick-re-init')) {
            $(thisCarousel).slick('unslick');
            $(thisCarousel).slick();
            $(thisCarousel).removeClass('needs-slick-re-init');
        }
    });
    $('.carousel-tabs-section-widget .tab-content > h3 > label').click(function () {
        var thisCarousel = $(this).closest('.tab-content').find('.slick-inline');
        if ($(thisCarousel).hasClass('needs-slick-re-init')) {
            $(thisCarousel).slick('unslick');
            $(thisCarousel).slick();
            $(thisCarousel).removeClass('needs-slick-re-init');
        }
    });
});

